import * as React from 'react';
import {FunctionComponent, useEffect, useState} from 'react';
import {observer} from 'mobx-react-lite';
import {UptimeEventListDto} from '../../swagger';
import {formatDateTime} from '../../helpers/helpers';
import {api} from '../../ApiFacade';

export interface FlatListUptimeInfoProps {
    logId: string;
    limit?: number;
}

export const UptimeEventsListComponent: FunctionComponent<FlatListUptimeInfoProps> = observer(({logId, limit}) => {
    const [data, setData] = useState<UptimeEventListDto>();
    const [page, setPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);
        const result = api().uptimeEvents.apiUptimeEventsListGet({
            limit: limit ?? 10,
            logId,
            page: page
        }).then(res => {
            setData(res.content);
            setIsLoading(false);
        });
        return;
    }, [page]);

    return <div className="bg-m-gray-2 text-m-gray-6 mt-4 p-2 break-all text-xs w-full">
        <table className={isLoading ? 'opacity-20' : 'opacity-100'}>
            <thead>
            <tr>
                <td style={{width: 10}}/>
                <td style={{width: 150}}>
                    Date
                </td>
                <td style={{width: 70}}>
                    Status code
                </td>
                <td>
                    Response
                </td>
            </tr>
            </thead>
            <tbody>
            {data?.items !== undefined && data.items?.map(x => {
                return <tr key={x.uptimeEventId}>
                    <td><span className={`h-2 w-2 inline-block rounded-full mr-2 ${x.isSuccessStatusCode ? 'Trace' : 'Error'}`}/></td>
                    <td>
                        {formatDateTime(x.eventTime)}
                    </td>
                    <td>
                        {x.statusCode}
                    </td>
                    <td className="truncate" title={x.errorResponse ?? ''}>
                        {x.errorResponse?.substr(0, 50)}
                    </td>
                </tr>;
            })}
            </tbody>
        </table>
        <div className="flex flex-row w-full grid-cols-3 gap-4 mt-2">
            <div>
                Page {page} of {data?.totalPages}
            </div>
            <div/>
            <div>
                <button onClick={() => setPage(page - 1)} disabled={page === 1}>Previous page</button>
            </div>
            <div className="col-end-1">
                <button onClick={() => setPage(page + 1)} disabled={page === data?.totalPages}>Next page</button>
            </div>
        </div>


    </div>;
    }
);
